import React from 'react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const AuthLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2 text-center">
          Iniciar sesión
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Página de inicio de sesión (próximamente)
        </p>
        <Button
          variant="outline"
          onClick={() => navigate('/')}
          className="w-full"
        >
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default AuthLogin;
